'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef } from 'react';
import { InternalProvider, useComponentDeprecation } from '../../util';
import { SelectionChip } from './SelectionChip';
import { ChipsContainerElement } from './elements';

/** @deprecated */
export const ManualSelectionChips = ({
  id,
  className = '',
  size = 'small',
  type = 'selection',
  layout = 'wrap',
  chips = [],
  options = {},
  ...rest
}) => {
  useComponentDeprecation({
    name: 'ManualSelectionChips',
    version: 'v5',
    alternative: 'the new FilterChip'
  });
  const sliderRef = useRef(null);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(ChipsContainerElement, _extends({
    "data-aui": "chips.manual-selection",
    ref: sliderRef,
    id: id,
    className: className,
    tabIndex: -1,
    $layout: layout
  }, rest), chips.map(chip => /*#__PURE__*/React.createElement(SelectionChip, _extends({
    key: chip.label
  }, chip, {
    type: type,
    size: size,
    edgeItemsMargin: options.edgeItemsMargin
  })))));
};